import { render } from "./ReservationsRibbon.vue?vue&type=template&id=de886120&scoped=true"
import script from "./ReservationsRibbon.vue?vue&type=script&lang=js"
export * from "./ReservationsRibbon.vue?vue&type=script&lang=js"

import "./ReservationsRibbon.vue?vue&type=style&index=0&id=de886120&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de886120"]])

export default __exports__